/* eslint-disable react-hooks/exhaustive-deps */
import { Area } from '@antv/g2plot';
import React, { useEffect, useRef, useState } from 'react';
import Frame from '../frame';
import Style from './style';
import Metrics from '../metrics';
import { mapData } from './helper';
import { getRange } from '../mitigation-actions-trend/helper';
import { useChartHelper } from '../../../../../../../helpers/Charts';

const CustomTooltipContent = (data, t) => {
  const items = data ? data.map ? data.map((d) => `
    <div class="item">
      <div>
        <div class="identifier" style="background: ${d.color}"></div>
      </div>
      <div class="title">
        <span>${t(`${d.name} Incident`)}</span>
      </div>
      <div class="value">
        <span>${d.data.realValue}</span>
      </div>
    </div>
  `) : [] : [];

  return `
    <div class="custom-tooltip">
      ${items.join('')}
    </div>
  `;
};

const IncidentsTrend = ({
  data = null,
  period = 'past12Months',
  t = (t) => t,
}) => {
  const container = useRef();
  const [graph, setGraph] = useState(null);
  const [frameActions, setFrameActions] = useState(null);
  const [metricsValues, setMetricsValues] = useState([
    { color: "#FADB14", label: "Minor", toggled: true },
    { color: "#FA8C16", label: "Moderate", toggled: true },
    { color: "#FF4D4F ", label: "Major", toggled: true },
  ]);

  const {
    getFilteredData,
    getFilteredColors,
    getActiveFilterData,
    setDaily,
    setWeekly,
    setMonthly,
    initialConfig,
  } = useChartHelper({
    metricsValues,
    period,
    data,
    frameActions,
    t,
    tooltTip: CustomTooltipContent,
  });

  useEffect(() => {
    if (data) {
      if (data.pastMonth && data.past3Months && data.past12Months) {
        mapData({
          data,
          setDaily,
          setWeekly,
          setMonthly,
        });
      }
    }
  }, [data]);

  useEffect(() => {
    if (!graph && metricsValues && getActiveFilterData) {
      const area = new Area(container.current, {
        data: getActiveFilterData || [],
        ...initialConfig(metricsValues),
        areaStyle: {
          fillOpacity: 1,
        },
        yAxis: {
          tickMethod: (a) => getRange(a.max),
        },
        color: ['#FADB14', '#FA8C16', '#FF4D4F'],
      });

      setGraph(area);
      area.render();
    } else if (graph && getActiveFilterData) {
      graph.update({
        data: getFilteredData(getActiveFilterData),
        color: getFilteredColors,
        animation: false,
      });
    }
  }, [metricsValues, getActiveFilterData]);

  return <Frame
    title={t('Dashboard::Incident Reports')}
    onInit={actions => setFrameActions(actions)}
  >
    <Style>
      <div className="chart-container" ref={container} />
      {metricsValues && (
        <Metrics
          t={t}
          title={t('Dashboard::Severity')}
          metricsValues={metricsValues}
          setMetricsValues={setMetricsValues}
          isEmpty={false}
          reversed
        />
      )}
    </Style>
  </Frame>;
}

export default IncidentsTrend;
